'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _lodash = require('lodash.uniqueid');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// for event emulation
var preventDefault = function preventDefault() {};
var stopPropagation = function stopPropagation() {};

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;

        _this._handlePaste = function (event) {
            var value = event.clipboardData.getData('Text');

            if (typeof _this.props.ceilFormat === 'function') {
                value = _this.props.ceilFormat(value);
            }

            if (value) {
                _this.value = value;
                setTimeout(function () {
                    _this._dispatchSyntheticEvent();
                    _this._moveCarriage();
                }, 0);
            }

            if (typeof _this.props.onPaste === 'function') {
                _this.props.onPaste(event);
            }

            return _this;
        };

        _this._handleFocus = function (event) {
            if (!_this.state.focus) {
                _this.setState({ focus: true }).then(function () {
                    return _this._moveCarriage();
                });
            }

            if (typeof _this.props.onFocus === 'function') {
                _this.props.onFocus(event);
            }

            return _this;
        };

        _this._handleBlur = function (event) {
            var ceils = _this._inputRefs ? Object.keys(_this._inputRefs) : [],
                activeElement = window.document.activeElement,
                onResolve = void 0,
                needBlur = void 0;

            needBlur = !ceils.find(function (item) {
                return item === activeElement;
            });

            onResolve = function onResolve() {
                if (typeof _this.props.onBlur === 'function') {
                    _this.props.onBlur(event);
                }
            };

            if (_this.state.focus && needBlur) {
                _this.setState({ focus: false }).then(function () {
                    return onResolve(event);
                });
            } else {
                onResolve(event);
            }

            return _this;
        };

        _this._handleChange = function (event) {
            _this._updateCeilValue(event.target.id, event.target.value).then(function () {
                return _this._moveCarriage();
            }).then(function () {
                _this._dispatchSyntheticEvent();
            });

            return _this;
        };

        _this._handleKeyDown = function (event) {
            var keyCode = event.keyCode,
                target = event.target;

            // backspace and delete key
            // must remove last digit in previous ceil

            if ((keyCode === 8 || keyCode === 46) && !target.value) {
                event.preventDefault();

                var value = _this.value,

                // previous ceil
                prevIndex = value.length / _this.props.maxLength - 1,
                    prevId = _this.id + prevIndex,
                    prevValue = _this.state[prevId];

                if (prevValue) {
                    // remove last digit in prev ceil
                    _this._updateCeilValue(prevId, prevValue.substring(0, prevValue.length - 1)).then(function () {
                        return _this._moveCarriage();
                    }).then(function () {
                        _this._dispatchSyntheticEvent();
                    });
                }
            }
        };

        _this._updateCeilValue = function (id, value) {
            if (typeof _this.props.ceilFormat === 'function') {
                value = _this.props.ceilFormat(value);
            }

            return _this.setState(_defineProperty({}, id, value));
        };

        _this._makeInputRef = function (el) {
            if (el) {
                _this._inputRefs[el.id] = el;
            }
        };

        _this.state = {
            hover: false,
            focus: false
        };

        _this.id = (0, _lodash2.default)('separated_input');
        _this._inputRefs = {};

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(this);
            }

            if (this.props.value) {
                this.value = this.props.value;
            }

            return this;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.value !== prevProps.value) {
                this.value = this.props.value;
            }

            return this;
        }
    }, {
        key: '_dispatchSyntheticEvent',
        value: function _dispatchSyntheticEvent() {
            var event = {
                target: this,
                currentTarget: this,
                preventDefault: preventDefault,
                stopPropagation: stopPropagation,
                type: 'input'
            };

            if (typeof this.props.onChange === 'function') {
                this.props.onChange(event);
            }
        }
    }, {
        key: 'focus',
        value: function focus() {
            this._moveCarriage();
            return this;
        }
    }, {
        key: '_moveCarriage',
        value: function _moveCarriage() {
            var activeElement = void 0,
                value = this.value,
                activePosition = void 0;

            // position for next selection
            activePosition = value.length / this.props.maxLength;

            // if next position out of count length - set last
            if (activePosition === this.props.count) {
                activePosition -= 1;
                // if ceil is not fully filled
            } else if (activePosition % 1 !== 0) {
                activePosition = Math.floor(activePosition);
            }

            activeElement = this._inputRefs[this.id + activePosition];

            if (activeElement && activeElement !== window.document.activeElement) {
                activeElement.focus();

                // возврат коретки в конец введенного текста
                try {
                    activeElement.selectionStart = activeElement.value.length;
                } catch (e) {}
            }
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.state.focus) + String(this.state.hover) + String(this.props.wide) + String(this.props.error);
        }
    }, {
        key: '_handleHover',
        value: function _handleHover() {
            return this.setState({ hover: true });
        }
    }, {
        key: '_handleRootBlur',
        value: function _handleRootBlur() {
            return this.setState({ hover: false });
        }
    }, {
        key: 'value',
        set: function set(value) {
            value = value || '';
            value = String(value);

            var i = 0,
                len = this.props.count,
                state = {};

            for (i; i < len; i++) {
                var id = this.id + i,
                    start = this.props.maxLength * i;

                state[id] = value.substr(start, this.props.maxLength);
            }

            this.setState(state);

            return value;
        },
        get: function get() {
            var value = '',
                i = 0,
                len = this.props.count;

            for (i; i < len; i++) {
                value += this.state[this.id + i] || '';
            }

            value = value.substr(0, this.props.maxLength * this.props.count);

            return value;
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    // type of native input
    type: 'text',
    // components label
    label: '',
    // components placeholder
    placeholder: 'XX',
    // count of inputs
    count: 4,
    // input length
    maxLength: 2,
    // onChange callback
    onChange: null,
    onBlur: null,
    onFocus: null,
    // 100% width
    wide: false
};
Main.propTypes = {
    type: _propTypes2.default.string,
    label: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    count: _propTypes2.default.number,
    maxLength: _propTypes2.default.number,
    ceilFormat: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    wide: _propTypes2.default.bool
};
Main.displayName = 'SeparatedInput';
exports.default = Main;